import React from 'react';
import { TYPO, R, SHADCN } from '../theme';
import { useEntityAccent } from './EntityAccent';

// ── <PageHeader> ────────────────────────────────────────────────────────────
// Entête harmonisé pour tous les onglets du dashboard.
// eyebrow (petit, uppercase, muted) + title (h1, ink) + meta optionnelle
// + actions à droite (boutons/icons). Filet inférieur 1px.
//
// Si un EntityAccentContext est fourni par l'onglet parent, l'entête se teinte :
// pastille colorée 8px avant le titre, eyebrow dans la couleur d'entité,
// filet inférieur teinté à 50% d'alpha. Sans context → comportement neutre.
export default function PageHeader({ eyebrow, title, meta, actions }) {
  const accent = useEntityAccent();
  const borderColor = accent ? `color-mix(in oklch, ${accent} 45%, transparent)` : SHADCN.border;
  const eyebrowColor = accent || SHADCN.mutedFg;

  return (
    <div style={{ marginBottom: 20, paddingBottom: 16, borderBottom: `1px solid ${borderColor}` }}>
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
        <div style={{ minWidth: 0 }}>
          {eyebrow && (
            <div style={{ ...TYPO.eyebrow, color: eyebrowColor, marginBottom: 8 }}>{eyebrow}</div>
          )}
          <div style={{ ...TYPO.h1, color: SHADCN.fg, display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
            {accent && (
              <span
                aria-hidden
                style={{
                  flexShrink: 0,
                  width: 10,
                  height: 10,
                  borderRadius: R.pill,
                  background: accent,
                  boxShadow: `0 0 0 4px color-mix(in oklch, ${accent} 16%, transparent)`,
                }}
              />
            )}
            <span style={{ minWidth: 0 }}>{title}</span>
          </div>
          {meta && (
            <div style={{ ...TYPO.body, ...TYPO.num, color: SHADCN.mutedFg, marginTop: 8 }}>{meta}</div>
          )}
        </div>
        {actions && (
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}
